var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"elevation":"0","loading":_vm.chartLoading,"height":"240"}},[_c('v-card-text',[_c('chart',{attrs:{"type":"area","height":"220","options":_vm.chart.options,"series":_vm.chart.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }